/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SystemRoleDto } from '../models/system-role-dto';
import { CreateRoleRequestDto } from '../models/create-role-request-dto';
import { UpdateRoleRequestDto } from '../models/update-role-request-dto';
import { DeleteRoleRequestDto } from '../models/delete-role-request-dto';
@Injectable({
  providedIn: 'root',
})
class SystemRoleService extends __BaseService {
  static readonly getApiSystemRolePath = '/api/SystemRole';
  static readonly postApiSystemRolePath = '/api/SystemRole';
  static readonly putApiSystemRolePath = '/api/SystemRole';
  static readonly deleteApiSystemRolePath = '/api/SystemRole';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  getApiSystemRoleResponse(): __Observable<__StrictHttpResponse<Array<SystemRoleDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SystemRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SystemRoleDto>>;
      })
    );
  }
  /**
   * @return Success
   */
  getApiSystemRole(): __Observable<Array<SystemRoleDto>> {
    return this.getApiSystemRoleResponse().pipe(
      __map(_r => _r.body as Array<SystemRoleDto>)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiSystemRoleResponse(body?: CreateRoleRequestDto): __Observable<__StrictHttpResponse<SystemRoleDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SystemRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SystemRoleDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiSystemRole(body?: CreateRoleRequestDto): __Observable<SystemRoleDto> {
    return this.postApiSystemRoleResponse(body).pipe(
      __map(_r => _r.body as SystemRoleDto)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  putApiSystemRoleResponse(body?: UpdateRoleRequestDto): __Observable<__StrictHttpResponse<SystemRoleDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SystemRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SystemRoleDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  putApiSystemRole(body?: UpdateRoleRequestDto): __Observable<SystemRoleDto> {
    return this.putApiSystemRoleResponse(body).pipe(
      __map(_r => _r.body as SystemRoleDto)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  deleteApiSystemRoleResponse(body?: DeleteRoleRequestDto): __Observable<__StrictHttpResponse<SystemRoleDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SystemRole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SystemRoleDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  deleteApiSystemRole(body?: DeleteRoleRequestDto): __Observable<SystemRoleDto> {
    return this.deleteApiSystemRoleResponse(body).pipe(
      __map(_r => _r.body as SystemRoleDto)
    );
  }
}

module SystemRoleService {
}

export { SystemRoleService }
